import { apiFetch, apiGet } from "@/lib/apiClient";
import { profileSchema } from "./schema";
import type { ProfilePatch } from "./schema";
import { profileCountriesSchema, profileCurrenciesSchema } from "./preferences";

export async function updateProfile(patch: ProfilePatch) {
  return profileSchema.parse(await apiFetch("/users/me/profile", { method: "PATCH", body: JSON.stringify(patch) }));
}
export async function uploadProfileImage(file: File) {
  const body = new FormData();
  body.append("image", file);
  return profileSchema.parse(await apiFetch("/users/me/profile/image", { method: "POST", body }));
}
export async function removeProfileImage() {
  return profileSchema.parse(await apiFetch("/users/me/profile/image", { method: "DELETE" }));
}
export async function getProfileCurrencies() {
  return profileCurrenciesSchema.parse(await apiGet("/currencies"));
}
export async function getProfileCountries() {
  return profileCountriesSchema.parse(await apiGet("/countries?fields=rank"));
}
